<template>
  <!-- 看板 -->
  <div class="bulletinBoard">
    <div class="top_centers">
      <div class="top flex">
        <div>
          本页展示为Demo数据
        </div>
        <div class="top_center flex">
          <div class="top_center_one">
            <p class="sz12 co70">国家/地区</p>
            <el-dropdown trigger="click" @visible-change='iconclick(1)'>
              <div class="sz16 scect flex">美国(UTC-5)<i v-if="iconstuts" class="el-icon-caret-right"></i><i v-else
                  class="el-icon-caret-bottom"></i></div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins cursor">
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美国(UTC-5)</div>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="top_center_two">
            <p class="sz12 co70">币种</p>
            <el-dropdown trigger="click" @visible-change='iconclick(2)'>
              <div class="sz16 scect flex">美元<i v-if="iconstuts2" class="el-icon-caret-right"></i><i v-else
                  class="el-icon-caret-bottom"></i></div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins cursor">
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美元 </div>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </div>

      <div class="list flex">
        <div class="list_li" v-for="(item, index) in hitsList" :key="index">
          <div style="font-size:14px;" class="list_top sz16">{{ item.yesterdaytext }}</div>
          <div class="list_center flex">
            <div style="font-size:16px;" class="p1 yb font_bo">{{ item.yesterdaynum }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="item.trend == 0" src="@/assets/img/dpt/ss.png" alt="">
                <img v-if="item.trend == 1" src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p style="font-size:20px;" :class="item.trend == 0 ? 'co9b' : 'co65'">{{ item.percentage }}</p>
                <p style="font-size:12px;" class=" co70">{{ item.jstext }}</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">{{ item.beforetext }}：{{ item.beforenum }}</div>
        </div>
      </div>
      <div class="list flex">
        <div class="list_li" v-for="(item, index) in distribution" :key="index">
          <div style="font-size:14px;" class="list_top sz16">{{ item.yesterdaytext }}</div>
          <div class="list_center flex">
            <div style="font-size:16px;" class="p1 yb font_bo">{{ item.yesterdaynum }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="item.trend == 0" src="@/assets/img/dpt/ss.png" alt="">
                <img v-if="item.trend == 1" src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p style="font-size:20px;" :class="item.trend == 0 ? 'co9b' : 'co65'">{{ item.percentage }}</p>
                <p style="font-size:12px;" class=" co70">{{ item.jstext }}</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">{{ item.beforetext }}：{{ item.beforenum }}</div>
        </div>
      </div>
      <div class="list flex">
        <div class="list_li" v-for="(item, index) in issue" :key="index">
          <div style="font-size:14px;" class="list_top sz16">{{ item.yesterdaytext }}</div>
          <div class="list_center flex">
            <div style="font-size:16px;" class="p1 yb font_bo">{{ item.yesterdaynum }}</div>
            <div class="list_center_top flex">
              <div class="list_center_img flex">
                <img v-if="item.trend == 0" src="@/assets/img/dpt/ss.png" alt="">
                <img v-if="item.trend == 1" src="@/assets/img/dpt/xj.png" alt="">
              </div>
              <div class="list_center_text">
                <p style="font-size:20px;" :class="item.trend == 0 ? 'co9b' : 'co65'">{{ item.percentage }}</p>
                <p style="font-size:12px;" class=" co70">{{ item.jstext }}</p>
              </div>
            </div>
          </div>
          <div style="font-size:12px;" class="list_bott">{{ item.beforetext }}：{{ item.beforenum }}</div>
        </div>
      </div>
      <div class="zwf"></div>
      <div class="top2 flex">
        <div class="top_center1 flex">
          <div class="top_center_two">
            <p class="sz12 co70">时间</p>
            <el-dropdown trigger="click" @visible-change='iconclick(3)'>
              <div class="sz16 scect flex">{{ setime }}<i v-if="iconstuts3" class="el-icon-caret-right"></i><i v-else
                  class="el-icon-caret-bottom"></i></div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="nologins cursor">
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 1 ? 'listba' : ''"
                      @click="listclick(1)">
                      过去7天</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 2 ? 'listba' : ''"
                      @click="listclick(2)">
                      过去30天</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 3 ? 'listba' : ''"
                      @click="listclick(3)">
                      过去90天</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="nologins_list center cursor" :class="listStuts == 4 ? 'listba' : ''"
                      @click="listclick(4)">
                      过去1年</div>
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="echart baff ru5">
        <div class="charts">
          <div id="myChart1" style="margin-top;10px;" :style="{ width: '100%', height: '100%', marginTop: '10px' }"></div>
        </div>
        <!-- <div class="broken flex">
          <div v-show="inputStsts == 1" class="broken_input cursor" @click="displaycha">
            <img src="@/assets/img/dpt/gg.jpg" alt="">
          </div>
          <div v-show="inputStsts == 2" class="broken_inputtwo cursor" @click="displaychatwo"></div>
          <div class="broken_inputsher">
            <img src="@/assets/img/dpt/zx.png" alt="">
          </div>
          <div class="cursor" v-if="p0stutscon == 1">分销订单数</div>
          <div class="cursor" v-if="p0stutscon == 2">重复订单</div>
        </div>
        <div class="broken2 flex">
          <div v-show="inputStsts2 == 1" class="broken_input cursor" @click="displaycha2">
            <img src="@/assets/img/dpt/gg.jpg" alt="">
          </div>
          <div v-show="inputStsts2 == 2" class="broken_inputtwo cursor" @click="displaychatwo2"></div>
          <div class="broken_inputsher">
            <img src="@/assets/img/dpt/zz.png" alt="">
          </div>
          <div v-if="p0stutscon == 1">分销金额</div>
          <div v-if="p0stutscon == 2">重复金额</div>
        </div>
        <div class="broken3 flex" v-if="p0stutscon == 1">
          <div class="broken3_one flex">
            <div class="broken_input cursor" @click="check">
              <input id="turn" v-model="subcheck" type="checkbox" /><label for="turn"></label>
            </div>
            <div>
              AvantLink
            </div>
          </div>
          <div class="flex">
            <div class="broken_input cursor" @click="checktwo">
              <input id="turn2" v-model="subchecktwo" type="checkbox" /><label for="turn2"></label>
            </div>
            <div>
              ShareASale
            </div>
          </div>
        </div> -->
        <div class="broken4 flex">
          <p class="p1 cursor" :class="p0stuts == 1 ? 'pico' : ''" @click="pzero(1)">数据概览</p>
          <p class="p2"></p>
          <p class="p3 cursor" :class="p0stuts == 2 ? 'pico' : ''" @click="pzero(2)">重复订单</p>
        </div>
      </div>
      <div class="proportion flex">
        <div class="proportion_left ru5">
          <div class="proportion_left_c ru5">
            <div class="top flex">
              <div class="top_center flex">
                <div class="top_center_one">
                  <p class="sz12 co70">联盟平台</p>
                  <el-dropdown trigger="click" @visible-change='iconclick(4)'>
                    <div class="sz16 scect flex">{{ Linkname }}<i v-if="iconstuts4" class="el-icon-caret-right"></i><i
                        v-else class="el-icon-caret-bottom"></i></div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="nologins cursor">
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="coksstuts == 1 ? 'listba' : ''"
                            @click="nameclick(1)">AvantLink</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="coksstuts == 2 ? 'listba' : ''"
                            @click="nameclick(2)">ShareASale</div>
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="top_center_two">
                  <p class="sz12 co70">时间</p>
                  <el-dropdown trigger="click" @visible-change='iconclick(5)'>
                    <div class="sz16 scect flex">{{ comime }}<i v-if="iconstuts5" class="el-icon-caret-right"></i><i
                        v-else class="el-icon-caret-bottom"></i></div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="nologins cursor">
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" v-for="(item, index) in avantLinkList" :key="index"
                            :class="comStuts == index ? 'listba' : ''" @click="comclick(item, index)">{{ item.time }}
                          </div>
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="imgs baff flex">
            <div class="w50">
              <div style="font-size:14px;" class="title_text font_bo center">{{ titleName }}</div>
              <div class="echatr">
                <div id="myChart2" :style="{ width: '100%', height: '100%' }"></div>
              </div>
            </div>
            <div class="imgs_inpusts flex">
              <div>
                <div class="broken3_one flex">
                  <div class="broken_input cursor">
                    <input id="turn3" v-model="subcheckboxs" @click="ckbox" type="checkbox" /><label for="turn3"></label>
                  </div>
                  <div>
                    <p style="font-size:12px" class="oocode">重复金额 / 总分销金额</p>
                    <p style="font-size:16px">{{ ShareAsale.repeats }} / {{ ShareAsale.distribution }}</p>
                  </div>
                </div>
                <div class="broken3_two flex">
                  <div class="broken_input cursor">
                    <input id="turn4" v-model="subcheckboxtwo" @click="ckboxtwo" type="checkbox" /><label
                      for="turn4"></label>
                  </div>
                  <div>
                    <p style="font-size:12px" class="oocode">重复订单数 / 总订单数</p>
                    <p style="font-size:16px">{{ ShareAsale.repeatsNum }} / {{ ShareAsale.distributionUnm }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="proportion_righ ru5">
          <div class="proportion_left_c ru5">
            <div class="top flex">
              <div class="top_center flex">
                <div class="top_center_two">
                  <p class="sz12 co70">时间</p>
                  <el-dropdown trigger="click" @visible-change='iconclick(6)'>
                    <div class="sz16 scect flex">{{ distributionName }}<i v-if="iconstuts6"
                        class="el-icon-caret-right"></i><i v-else class="el-icon-caret-bottom"></i></div>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="nologins cursor">
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 1 ? 'listba' : ''"
                            @click="distributionclik(1)">过去7天</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 2 ? 'listba' : ''"
                            @click="distributionclik(2)">过去30天</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 3 ? 'listba' : ''"
                            @click="distributionclik(3)">过去90天</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="nologins_list center cursor" :class="distributionStuts == 4 ? 'listba' : ''"
                            @click="distributionclik(4)">过去1年</div>
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="imgs baff">
            <div class="bott_list_top w100 flex">
              <div style="font-size:14px;" class="font_bo titles">联盟客类型分销占比</div>
              <div class="flex botts">
                <p style="font-size:12px;" class="p1 cursor" :class="p1stuts == 1 ? 'pico' : ''" @click="picos(1)">分销金额
                </p>
                <p style="font-size:12px;" class="p2"></p>
                <p style="font-size:12px;" class="p3 cursor" :class="p1stuts == 2 ? 'pico' : ''" @click="picos(2)">分销订单数
                </p>
              </div>
            </div>
            <div class="w100 bott_list3">
              <div id="myChart3" :style="{ width: '100%', height: '100%' }"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bott">
        <div class="tops flex">
          <div class="top_center flex">
            <div class="top_center_two">
              <p class="sz12 co70">时间</p>
              <el-dropdown trigger="click" @visible-change='iconclick(7)'>
                <div class="sz16 scect flex">{{ tabName }}<i v-if="iconstuts7" class="el-icon-caret-right"></i><i v-else
                    class="el-icon-caret-bottom"></i></div>
                <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 1 ? 'listba' : ''"
                        @click="tabclick(1)">过去7天</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 2 ? 'listba' : ''"
                        @click="tabclick(2)">过去30天</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 3 ? 'listba' : ''"
                        @click="tabclick(3)">过去90天</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="tableStuts == 4 ? 'listba' : ''"
                        @click="tabclick(4)">过去1年</div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <div class="bott_list ru5 baff">
          <div class="bott_list_top w100 flex">
            <div style="font-size:16px;" class="font_bo">{{ nametop }}</div>
            <div class="flex botts">
              <p style="font-size:12px;" class="p1 cursor" :class="p2stuts == 1 ? 'pico' : ''" @click="psick(1)">分销金额
              </p>
              <p style="font-size:12px;" class="p2"></p>
              <p style="font-size:12px;" class="p3 cursor" :class="p2stuts == 2 ? 'pico' : ''" @click="psick(2)">分销订单数
              </p>
            </div>
          </div>
          <div class="bott_list_center w100">
            <div style="font-size:12px;" class="toop_title w100 flex">
              <p class="one1">序号</p>
              <p class="fooer2">联盟客姓名</p>
              <p class="one">联盟客ID</p>
              <p class="fooer">推广网站</p>
              <p class="one">分销金额</p>
              <p class="one">分销订单数</p>
              <p class="one">联盟客类型</p>
              <p class="one">联盟客平台</p>
            </div>
            <div style="font-size:12px;" class="toop_center w100 flex" v-for="(item, index) in tabList" :key="index">
              <p class="one1">{{ index + 1 }}</p>
              <p class="fooer2">{{ item.name }}</p>
              <p class="one">{{ item.id }}</p>
              <p class="fooer">{{ item.url }}</p>
              <p class="one">{{ item.je }}</p>
              <p class="one">{{ item.oderunm }}</p>
              <p class="one">{{ item.type }}</p>
              <p class="one">{{ item.pt }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import icp from '../icp/icp.vue'
import { EventSourcePolyfill } from "event-source-polyfill";
export default {
  components: {
    icp
  },
  data() {
    return {
      listStutszs: 1,
      inputStsts: 1,
      inputStsts2: 1,
      subcheck: true,
      subchecktwo: true,
      p0stuts: 1,
      p1stuts: 1,
      p2stuts: 1,
      listStuts: 1,
      p0stutscon: 1,
      hitsList: [], //点击量
      distribution: [],//分销金额
      issue: [],
      time: [], // 时间
      avantLinkzx: [], // AvantLink分销订单数 折线图
      avantLinkzz: [],// AvantLink分销金额 柱状图
      ShareASaleje: [], // hareASale分销金额 折线图
      ShareASaleds: [],// ShareASale分销订单数 柱状图
      setime: '过去7天',
      ends: 100,
      nameone: 'AvantLink分销金额',
      nametwo: 'AvantLink分销订单数',
      comime: '',
      avantLinkList: [],
      comStuts: 0,
      Linkname: 'AvantLink',
      namestuts: 1,
      ShareAsale: {
        distribution: "", // 总分销金额
        repeats: "", // 重复金额
        proportionAmount: "", // 重复金额占比    
        distributionUnm: "", // 总分销订单数
        repeatsNum: "", // 重复订单数 
        OrderAmount: "", // 重复订单占比
      },
      ShareAsaleproportionAmount: 0,
      subcheckboxs: true,
      subcheckboxtwo: false,
      titleName: 'AvantLink 重复金额占比',
      comprehensivelist: [],
      distributionStuts: 1,
      distributionName: '过去7天',
      tabName: '过去7天',
      tabList: [],
      tableStuts: 1,
      coksstuts: 1,
      validParam: localStorage.getItem('validParam'),
      iconstuts: true,
      iconstuts2: true,
      iconstuts3: true,
      iconstuts4: true,
      iconstuts5: true,
      iconstuts6: true,
      iconstuts7: true,
      nametop: '联盟客分销金额TOP 5',  
      chartLegend1: ['AvantLink分销金额', 'ShareASale分销金额', 'AvantLink分销订单数', 'ShareASale分销订单数'],
      
      
      aiShow: false, // ai界面显示状态
      aiShow2: true,
      isend: false, //是否加载完
      textCount: 0,
      timer: null,
      // chatList: [{ content: '<P>您好，欢迎使用FOSHO AFF Copilot，我是您的联盟营销智能助手。</P><br/><p>FOSHO AFF是一个智能联盟营销云平台，在这里您可以洞悉联盟情报，与联盟伙伴合作增加销量，也可以管理多联盟平台数据、规避佣金损失。FOSHO的理念是Brand Intelligence, Shared Future. </p><br/><p>我是FOSHO推出的AFF Copilot智能助手，您可以向我提出有关联盟营销和FOSHO AFF平台的问题。我都会尽力回答哟~</p>', type: 'bot', status: false }],
      chatList: [],
      aimsg: '',
      aiRequest: false,
      leftDialogbox: false,
      messageTip: '',
      messageTipShow: false,
      sse: '',
  }
  },
  mounted() {
    if (this.validParam !== 'zhkb') {
      this.$bus.$emit('showNopermiss', true)
    }
    axios.post('/postUserList').then((res) => {
      this.hitsList = res.data.hitsList
      this.distribution = res.data.distribution
      this.issue = res.data.issue
    })
    this.bullmap()
    this.duplicatemap()
    this.comprehensivelistmap()
    this.tabListmap()
    // this.drawPie1()
  },
  methods: {
    bullmap() {
      axios.post('/bullList').then((res) => {
        this.time = res.data.data[0].time
        this.avantLinkzx = res.data.data[0].AvantLinkzxje
        this.avantLinkzz = res.data.data[0].AvantLinkzz
        this.ShareASaleje = res.data.data[0].ShareASaleje
        this.ShareASaleds = res.data.data[0].ShareASaleds
        this.$nextTick(() => {
          this.drawPie1()
        })
      })
    },
    repeatmap() {
      axios.post('/repeatList').then((res) => {
        this.time = res.data.data[0].time
        this.avantLinkzx = res.data.data[0].AvantLinkzxje
        this.avantLinkzz = res.data.data[0].AvantLinkzz
        this.ShareASaleje = []
        this.ShareASaleds = []
        this.$nextTick(() => {
          this.drawPie1()
        })
      })
    },
    duplicatemap() {
      axios.post('/duplicatelist').then((res) => {
        this.comime = res.data.avantLink[0].time
        this.avantLinkList = res.data.avantLink
        this.ShareAsale = res.data.avantLink[0]
        this.ShareAsaleproportionAmount = res.data.avantLink[0].proportionAmount
        this.$nextTick(() => {
          this.drawPie2()
        })
      })
    },
    comprehensivelistmap() {
      axios.post('/comprehensivelist').then((res) => {
        this.comprehensivelist = res.data.time1
        this.$nextTick(() => {
          this.drawPie3()
        })
      })
    },
    tabListmap() {
      axios.post('/jelist').then((res) => {
        this.tabList = res.data.time1
        this.tabList.map((item, index) => {
          if (item.name) {
            item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
          }
          if (item.url) {
            item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
          }
          if (item.id) {
            item.id = item.id.substring(0, 2) + "*****" + item.id.substring(item.id.length - 2)
          }
          if (item.je) {
            item.je = Number(item.je * 1.1).toFixed(2)

          }

        })
      })
    },
    tabclick(e) {
      this.tableStuts = e
      if (e == 1) {
        if (e == 1) {
          this.tabName = '过去7天'
          this.tabListmap()
        } else if (e == 2) {
          this.tabName = '过去30天'
          axios.post('/jelist').then((res) => {
            this.tabList = res.data.time2
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        } else if (e == 3) {
          this.tabName = '过去90天'
          axios.post('/jelist').then((res) => {
            this.tabList = res.data.time3
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        } else if (e == 4) {
          this.tabName = '过去1年'
          axios.post('/jelist').then((res) => {
            this.tabList = res.data.time4
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        }
      } else {
        if (e == 1) {
          this.tabName = '过去7天'
          axios.post('/tabList').then((res) => {
            this.tabList = res.data.time1
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        } else if (e == 2) {
          this.tabName = '过去30天'
          axios.post('/tabList').then((res) => {
            this.tabList = res.data.time2
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        } else if (e == 3) {
          this.tabName = '过去90天'
          axios.post('/tabList').then((res) => {
            this.tabList = res.data.time3
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        } else if (e == 4) {
          this.tabName = '过去1年'
          axios.post('/tabList').then((res) => {
            this.tabList = res.data.time4
            this.tabList.map((item, index) => {
              if (item.name) {
                item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
              }
              if (item.url) {
                item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
              }

            })
          })
        }
      }

    },
    psick(e) {
      this.tabName = '过去7天'
      this.tableStuts = 1
      this.p2stuts = e
      if (e == 1) {
        this.tabListmap()
        this.nametop = '联盟客分销金额TOP 5'
      } else {
        this.nametop = '联盟客分销订单数TOP 5'
        axios.post('/tabList').then((res) => {
          this.tabList = res.data.time1
          this.tabList.map((item, index) => {
            if (item.name) {
              item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
            }
            if (item.url) {
              item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
            }

          })
        })
      }
    },
    distributionclik(e) {
      this.distributionStuts = e
      this.comprehensivelistmap()
      if (this.p1stuts == 1) {
        if (e == 1) {
          this.distributionName = '过去7天'
        } else if (e == 2) {
          this.distributionName = '过去30天'
          axios.post('/comprehensivelist').then((res) => {
            this.comprehensivelist = res.data.time2
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        } else if (e == 3) {
          this.distributionName = '过去90天'
          axios.post('/comprehensivelist').then((res) => {
            this.comprehensivelist = res.data.time3
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        } else if (e == 4) {
          this.distributionName = '过去1年'
          axios.post('/comprehensivelist').then((res) => {
            this.comprehensivelist = res.data.time4
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        }
      } else {
        if (e == 1) {
          this.distributionName = '过去7天'
          axios.post('/domnebhtslist').then((res) => {
            this.comprehensivelist = res.data.time1
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        } else if (e == 2) {
          this.distributionName = '过去30天'
          axios.post('/domnebhtslist').then((res) => {
            this.comprehensivelist = res.data.time2
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        } else if (e == 3) {
          this.distributionName = '过去90天'
          axios.post('/domnebhtslist').then((res) => {
            this.comprehensivelist = res.data.time3
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        } else if (e == 4) {
          this.distributionName = '过去1年'
          axios.post('/domnebhtslist').then((res) => {
            this.comprehensivelist = res.data.time4
            this.$nextTick(() => {
              this.drawPie3()
            })
          })
        }
      }

    },
    // 折线图显示影藏
    displaycha() {
      this.inputStsts = 2
      if (this.p0stuts == 1) {
        this.avantLinkzz = []
        this.ShareASaleds = []
        this.$nextTick(() => {
          this.drawPie1()
        })
      } else {
        this.avantLinkzz = []
        this.$nextTick(() => {
          this.drawPie1()
        })
      }

    },
    displaychatwo() {
      this.inputStsts = 1
      if (this.p0stuts == 1) {
        axios.post('/bullList').then((res) => {
          if (this.ends == 50) {
            this.time = res.data.data[1].time
            this.avantLinkzz = res.data.data[1].AvantLinkzz
            this.ShareASaleds = res.data.data[1].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 100) {
            this.time = res.data.data[0].time
            this.avantLinkzz = res.data.data[0].AvantLinkzz
            this.ShareASaleds = res.data.data[0].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 20) {
            this.time = res.data.data[2].time
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleds = res.data.data[2].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 5) {
            this.time = res.data.data[3].time
            this.avantLinkzz = res.data.data[3].AvantLinkzz
            this.ShareASaleds = res.data.data[3].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }

        })
      } else {
        axios.post('/repeatList').then((res) => {
          if (this.ends == 50) {
            this.time = res.data.data[1].time
            this.avantLinkzx = res.data.data[1].AvantLinkzxje
            this.avantLinkzz = res.data.data[1].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 100) {
            this.time = res.data.data[0].time
            this.avantLinkzx = res.data.data[0].AvantLinkzxje
            this.avantLinkzz = res.data.data[0].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 20) {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 5) {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }

        })
      }

    },
    // 柱状图显示隐藏
    displaycha2() {
      this.inputStsts2 = 2
      if (this.p0stuts == 1) {
        this.avantLinkzx = []
        this.ShareASaleje = []
        this.$nextTick(() => {
          this.drawPie1()
        })
      } else {
        this.avantLinkzx = []
        this.$nextTick(() => {
          this.drawPie1()
        })
      }
    },
    displaychatwo2() {
      this.inputStsts2 = 1
      if (this.p0stuts == 1) {
        axios.post('/bullList').then((res) => {
          if (this.ends == 50) {
            this.time = res.data.data[1].time
            this.avantLinkzx = res.data.data[1].AvantLinkzxje
            this.ShareASaleje = res.data.data[1].ShareASaleje
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }
          else if (this.ends == 100) {
            this.time = res.data.data[0].time
            this.avantLinkzx = res.data.data[0].AvantLinkzxje
            this.ShareASaleje = res.data.data[0].ShareASaleje
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 20) {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.ShareASaleje = res.data.data[2].ShareASaleje
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 5) {
            this.time = res.data.data[3].time
            this.avantLinkzx = res.data.data[3].AvantLinkzxje
            this.ShareASaleje = res.data.data[3].ShareASaleje
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }

        })
      } else {
        axios.post('/repeatList').then((res) => {
          if (this.ends == 50) {
            this.time = res.data.data[1].time
            this.avantLinkzx = res.data.data[1].AvantLinkzxje
            this.avantLinkzz = res.data.data[1].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 100) {
            this.time = res.data.data[0].time
            this.avantLinkzx = res.data.data[0].AvantLinkzxje
            this.avantLinkzz = res.data.data[0].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              this.drawPie1()
            })
          } else if (this.ends == 20) {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              this.drawPie1()
            })
          } else if (this.ends == 5) {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              this.drawPie1()
            })
          }

        })
      }

    },
    // 切换类型
    check() {
      if (this.subcheck) {
        this.avantLinkzx = []
        this.avantLinkzz = []
        this.$nextTick(() => {
          setTimeout(() => {
            this.drawPie1()
          }, 500)
        })
      } else {
        axios.post('/bullList').then((res) => {
          if (this.ends == 50) {
            this.time = res.data.data[1].time
            this.avantLinkzx = res.data.data[1].AvantLinkzxje
            this.avantLinkzz = res.data.data[1].AvantLinkzz
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }
          else if (this.ends == 100) {
            this.time = res.data.data[0].time
            this.avantLinkzx = res.data.data[0].AvantLinkzxje
            this.avantLinkzz = res.data.data[0].AvantLinkzz
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 20) {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 5) {
            this.time = res.data.data[3].time
            this.avantLinkzx = res.data.data[3].AvantLinkzxje
            this.avantLinkzz = res.data.data[3].AvantLinkzz
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }

        })
      }
    },
    checktwo() {
      if (this.subchecktwo) {
        this.ShareASaleje = []
        this.ShareASaleds = []
        this.$nextTick(() => {
          setTimeout(() => {
            this.drawPie1()
          }, 500)
        })
      } else {
        axios.post('/bullList').then((res) => {
          if (this.ends == 50) {
            this.time = res.data.data[1].time
            this.ShareASaleje = res.data.data[1].ShareASaleje
            this.ShareASaleds = res.data.data[1].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          }
          else if (this.ends == 100) {
            this.time = res.data.data[0].time
            this.ShareASaleje = res.data.data[0].ShareASaleje
            this.ShareASaleds = res.data.data[0].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 20) {
            this.time = res.data.data[2].time
            this.ShareASaleje = res.data.data[2].ShareASaleje
            this.ShareASaleds = res.data.data[2].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          } else if (this.ends == 5) {
            this.time = res.data.data[3].time
            this.ShareASaleje = res.data.data[3].ShareASaleje
            this.ShareASaleds = res.data.data[3].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })

          }

        })
      }
    },
    pzero(e) {
      this.p0stuts = e
      this.listStuts = 1
      this.setime = '过去7天'
      this.ends = 100
      if (e == 1) {
        this.p0stutscon = 1
        this.p0stuts = 1
        this.nameone = 'AvantLink分销金额',
          this.nametwo = 'AvantLink分销订单数'
        this.chartLegend1 = ['AvantLink分销金额', 'ShareASale分销金额', 'AvantLink分销订单数', 'ShareASale分销订单数']
        this.bullmap()
      } else {
        this.p0stuts = 2
        this.p0stutscon = 2
        this.nameone = '重复金额',
          this.nametwo = '重复订单数'
        this.chartLegend1 = ['重复金额', '重复订单数']
        this.repeatmap()
      }
    },
    picos(e) {
      this.distributionStuts = 1
      this.distributionName = '过去7天'
      this.p1stuts = e
      if (e == 1) {
        this.comprehensivelistmap()
      } else {
        // debugger
        axios.post('/domnebhtslist').then((res) => {
          this.comprehensivelist = res.data.time1
          this.$nextTick(() => {
            setTimeout(() => {
              this.drawPie3()
            }, 500)
          })

        })
      }

    },

    // 选择周期
    listclick(e) {
      this.listStuts = e
      if (this.p0stuts == 1) {
        if (e == 1) {
          this.setime = '过去7天'
          this.ends = 100
          axios.post('/bullList').then((res) => {
            this.time = res.data.data[0].time
            this.avantLinkzx = res.data.data[0].AvantLinkzxje
            this.avantLinkzz = res.data.data[0].AvantLinkzz
            this.ShareASaleje = res.data.data[0].ShareASaleje
            this.ShareASaleds = res.data.data[0].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        } else if (e == 2) {
          this.setime = '过去30天'
          this.ends = 50
          axios.post('/bullList').then((res) => {
            this.time = res.data.data[1].time
            this.avantLinkzx = res.data.data[1].AvantLinkzxje
            this.avantLinkzz = res.data.data[1].AvantLinkzz
            this.ShareASaleje = res.data.data[1].ShareASaleje
            this.ShareASaleds = res.data.data[1].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        } else if (e == 3) {
          this.setime = '过去90天'
          this.ends = 20
          axios.post('/bullList').then((res) => {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleje = res.data.data[2].ShareASaleje
            this.ShareASaleds = res.data.data[2].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        } else if (e == 4) {
          this.setime = '过去1年'
          this.ends = 5
          axios.post('/bullList').then((res) => {
            this.time = res.data.data[3].time
            this.avantLinkzx = res.data.data[3].AvantLinkzxje
            this.avantLinkzz = res.data.data[3].AvantLinkzz
            this.ShareASaleje = res.data.data[3].ShareASaleje
            this.ShareASaleds = res.data.data[3].ShareASaleds
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })

          })
        }
      } else {
        if (e == 1) {
          this.setime = '过去7天'
          this.ends = 100
          axios.post('/repeatList').then((res) => {
            this.time = res.data.data[0].time
            this.avantLinkzx = res.data.data[0].AvantLinkzxje
            this.avantLinkzz = res.data.data[0].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        } else if (e == 2) {
          this.setime = '过去30天'
          this.ends = 50
          axios.post('/repeatList').then((res) => {
            this.time = res.data.data[1].time
            this.avantLinkzx = res.data.data[1].AvantLinkzxje
            this.avantLinkzz = res.data.data[1].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        } else if (e == 3) {
          this.setime = '过去90天'
          this.ends = 20
          axios.post('/repeatList').then((res) => {
            this.time = res.data.data[2].time
            this.avantLinkzx = res.data.data[2].AvantLinkzxje
            this.avantLinkzz = res.data.data[2].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        } else if (e == 4) {
          this.setime = '过去1年'
          this.ends = 5
          axios.post('/repeatList').then((res) => {
            this.time = res.data.data[3].time
            this.avantLinkzx = res.data.data[3].AvantLinkzxje
            this.avantLinkzz = res.data.data[3].AvantLinkzz
            this.ShareASaleje = []
            this.ShareASaleds = []
            this.$nextTick(() => {
              setTimeout(() => {
                this.drawPie1()
              }, 500)
            })
          })
        }

      }

    },
    nameclick(e) {
      this.coksstuts = e
      this.namestuts = e
      this.subcheckboxs = true
      this.subcheckboxtwo = false
      if (e == 1) {
        this.Linkname = 'AvantLink'
        this.duplicatemap()
        this.titleName = 'AvantLink 重复金额占比'
      } else {
        this.Linkname = 'ShareASale'
        axios.post('/duplicatelist').then((res) => {
          this.comime = res.data.ShareAsale[0].time
          this.avantLinkList = res.data.ShareAsale
          this.ShareAsale = res.data.ShareAsale[0]
          this.ShareAsaleproportionAmount = res.data.ShareAsale[0].proportionAmount
          this.$nextTick(() => {
            setTimeout(() => {
              this.drawPie2()
            }, 500)
          })
        })
        this.titleName = 'ShareASale 重复金额占比'
      }

    },
    // 重复订单选择时间
    comclick(e, index) {
      this.comime = e.time
      this.comStuts = index
      this.ShareAsale = e
      // this.$nextTick(() => {
      //   this.drawPie2()
      // })
      setTimeout(() => {
        this.drawPie2()
      }, 500)
      if (this.subcheckboxs) {
        this.ShareAsaleproportionAmount = e.proportionAmount
        // this.$nextTick(() => {
        //   this.drawPie2()
        // })
        setTimeout(() => {
          this.drawPie2()
        }, 500)
      } else {
        this.ShareAsaleproportionAmount = e.OrderAmount
        // this.$nextTick(() => {
        //   this.drawPie2()
        // })
        setTimeout(() => {
          this.drawPie2()
        }, 500)
      }
    },
    ckbox() {
      this.subcheckboxs = !this.subcheckboxs
      axios.post('/duplicatelist').then((res) => {
        if (this.subcheckboxs) {
          this.ShareAsaleproportionAmount = res.data.avantLink[0].proportionAmount
          if (this.namestuts == 1) {
            this.titleName = 'AvantLink 重复金额占比'
          } else {
            this.titleName = 'ShareASale 重复金额占比'
          }
          this.subcheckboxtwo = false
          this.$nextTick(() => {
            setTimeout(() => {
              this.drawPie2()
            }, 500)
          })
        } else {
          this.subcheckboxtwo = true
          this.ShareAsaleproportionAmount = res.data.avantLink[0].OrderAmount
          if (this.namestuts == 1) {
            this.titleName = 'AvantLink 重复订单占比'
          } else {
            this.titleName = 'ShareASale 重复订单占比'
          }

          this.$nextTick(() => {
            setTimeout(() => {
              this.drawPie2()
            }, 500)
          })
        }
      })

    },
    ckboxtwo() {
      this.subcheckboxtwo = !this.subcheckboxtwo
      axios.post('/duplicatelist').then((res) => {
        if (this.subcheckboxtwo) {
          this.ShareAsaleproportionAmount = res.data.avantLink[0].OrderAmount
          this.subcheckboxs = false
          if (this.namestuts == 1) {
            this.titleName = 'AvantLink 重复订单占比'
          } else {
            this.titleName = 'ShareASale 重复订单占比'
          }

          this.$nextTick(() => {
            setTimeout(() => {
              this.drawPie2()
            }, 500)
          })
        } else {
          this.subcheckboxs = true
          this.ShareAsaleproportionAmount = res.data.avantLink[0].proportionAmount

          if (this.namestuts == 1) {
            this.titleName = 'AvantLink 重复金额占比'
          } else {
            this.titleName = 'ShareASale 重复金额占比'
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.drawPie2()
            }, 500)
          })
        }
      })
    },
    iconclick(e) {
      if (e == 1) {
        this.iconstuts = !this.iconstuts
      } else if (e == 2) {
        this.iconstuts2 = !this.iconstuts2
      } else if (e == 3) {
        this.iconstuts3 = !this.iconstuts3
      } else if (e == 4) {
        this.iconstuts4 = !this.iconstuts4
      } else if (e == 5) {
        this.iconstuts5 = !this.iconstuts5
      } else if (e == 6) {
        this.iconstuts6 = !this.iconstuts6
      } else if (e == 7) {
        this.iconstuts7 = !this.iconstuts7
      }

    },
    drawPie1() {
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          top: '15%',
          right: '3%',
          bottom: '15%',
          containLabel: true
        },
        legend: {
          bottom: 30,
          data: this.chartLegend1
        },
        xAxis: [
          {
            type: 'category',
            data: this.time,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            show: true,
            position: 'left',
            name: '订单数',
            interval: 5000,
            minInterval: 1,
            axisLabel: {
              formatter: '{value} '
            }
          },
          {
            type: 'value',
            name: '金额',
            position: 'right',
            interval: 5000,
            axisLabel: {
              formatter: '{value} '
            },
            minInterval: 1,
          },
        ],
        series: [
          {
            name: this.nameone,
            type: 'bar',
            barWidth: 16,//柱图宽度
            yAxisIndex: 1,
            itemStyle: {    //柱状图的背景色
              normal: {
                color: '#FC6780'
              }
            },
            data: this.avantLinkzx
          },
          {
            name: 'ShareASale分销金额',
            type: 'bar',
            barWidth: 16,//柱图宽度
            yAxisIndex: 1,
            itemStyle: {    //柱状图的背景色
              normal: {
                color: '#FEC776'
              }
            },
            data: this.ShareASaleje
          },
          {
            name: this.nametwo,
            type: 'line',
            symbolSize: 10,
            color: '#FC6780',
            data: this.avantLinkzz
          },
          {
            name: 'ShareASale分销订单数',
            type: 'line',
            symbolSize: 10,

            color: '#FEC776',
            data: this.ShareASaleds
          }
        ],
        dataZoom: [
          {
            show: false, // 为true 滚动条出现
            realtime: true,
            type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
            height: 10, // 表示滚动条的高度，也就是粗细
            start: 0, // 表示默认展示20%～80%这一段。
            end: this.ends,
            handleSize: 0,      //两边手柄尺寸
            dataBackground: {
              areaStyle: {
                color: '#fff'
              }
            },
            backgroundColor: '#fff',
            borderColor: "#ffffff",
            fillerColor: '#fff',
            moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
            moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
            zoomLock: true,         //是否只平移不缩放
            showDetail: false, //拖拽时是否展示滚动条两侧的文字
            zoomOnMouseWheel: true,  // 关闭滚轮缩放
            moveOnMouseWheel: true, // 开启滚轮平移
            moveOnMouseMove: true,  // 鼠标移动能触发数据窗口平移 
            bottom: 10,
          },
          {//没有下面这块的话，只能拖动滚动条，鼠标滚轮在区域内不能控制外部滚动条
            type: 'inside',
            xAxis: 0,
            zoomOnMouseWheel: false,  //滚轮是否触发缩放
            moveOnMouseMove: true,  //鼠标滚轮触发滚动
            moveOnMouseWheel: true
          }
        ]
      };

      // 增加了一个隐藏的x轴，用来控制线图的点的位置
      option.xAxis[1] = {
        type: 'value',
        // max: option.xAxis[0].data.length * 100,
        show: false
      }
      myChart.setOption(option);


    },
    drawPie2() {

      // 基于准备好的dom，初始化echarts实例
      let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      let option = {
        series: [
          {
            type: 'gauge',
            center: ['50%', '50%'],
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 12,
            itemStyle: {
              color: '#7892EC'
            },
            progress: {
              show: true,
              width: 30
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 30
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            anchor: {
              show: true
            },
            title: {
              show: true
            },
            detail: {
              valueAnimation: true,
              width: '100%',
              lineHeight: 15,
              borderRadius: 8,
              offsetCenter: [0, '-15%'],
              fontSize: 12,
              fontWeight: 'bolder',
              formatter: '百分比\n {value}%',
              color: '#7892EC'
            },
            data: [
              {
                value: this.ShareAsaleproportionAmount
              }
            ],

          },
        ]
      };

      myChart2.setOption(option);
    },
    drawPie3() {
      let myChart3 = this.$echarts.init(document.getElementById("myChart3"));
      myChart3.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} {c} ({d}%)",
          textStyle: {
            fontSize: 14
          }
        },
        legend: {
          orient: 'horizontal',
          right: 10,
          top: '10%',
          icon: "rect",
          itemGap: 10,
          x: '50%',
          itemHeight: 15, // 图例icon高度
          itemWidth: 15, // 图例icon宽度
          padding: [25, 0],
          textStyle: {
            fontSize: 10
          }
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "90%"],
            data: this.comprehensivelist,
            color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68',],
            itemStyle: {
              normal: {
                // borderWidth: 5,
                // borderColor: "#fff",
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },

            center: ['20%', '50%'],
          },

        ],
      });
      myChart3.resize();
    }
  }
}

</script>
<style lang="less" scoped>
.oocode {
  color: rgba(0, 0, 0, 0.5);
  margin-top: -2px;
}

.listba {
  // background:#a6a8bf;
  background: rgba(166, 168, 191, 0.25) !important;
}

.nologins {
  width: 120px;
  border-radius: 14px;

  .nologins_title {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(64, 64, 64, 0.25);
    padding-left: 7px;
  }

  .nologins_list {
    width: 100%;
    height: 32px;
    line-height: 32px;
    margin: 10px 0;
  }
}

.top_center1 {
  width: 120px;
  position: absolute;
  right: 0;

  .top_center_two {
    width: 100%;

    .scect {
      border-bottom: 1px solid;
      position: relative;
      align-items: center;
      padding-bottom: 3px;
      margin-top: 5px;

      i {
        position: absolute;
        right: 0;
      }
    }
  }
}

.bulletinBoard {
  // width: 100%;
  // height: 100%;
  padding-top: 69px;
  background: #fafafd;
  box-sizing: border-box;

  .pico {
    background: #be3c6e;
    border-radius: 5px 5px 5px 5px;
    opacity: 1;
    border: 1px solid #be3c6e;
    color: #fff;
  }

  .top {
    width: 100%;
    height: 84px;
    border-bottom: 2px solid rgba(166, 168, 191, 0.25);
    align-items: center;
    position: relative;
    margin-bottom: 24px;

    .top_center {
      width: 300px;
      position: absolute;
      right: 0;

      .top_center_one {
        width: 40%;
        margin-right: 20%;

        .scect {
          border-bottom: 1px solid;
          position: relative;
          align-items: center;
          padding-bottom: 3px;
          margin-top: 5px;

          i {
            position: absolute;
            right: 0;
          }
        }
      }

      .top_center_two {
        width: 40%;

        .scect {
          border-bottom: 1px solid;
          position: relative;
          align-items: center;
          padding-bottom: 3px;
          margin-top: 5px;

          i {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }

  .top2 {
    width: 100%;
    height: 84px;
    align-items: center;
    position: relative;
    margin-bottom: 24px;

    .top_center {
      width: 120px;
      position: absolute;
      right: 0;

      .top_center_two {
        width: 100%;

        .scect {
          border-bottom: 1px solid;
          position: relative;
          align-items: center;
          padding-bottom: 3px;
          margin-top: 5px;

          i {
            position: absolute;
            right: 0;
          }
        }
      }
    }
  }

  .list {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 34px;
    cursor: pointer;
    transition: all 0.6s;

    .list_li {
      width: 23%;
      height: 176px;
      background: #fff;
      box-shadow: 6px 6px 54px 1px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(166, 168, 191, 0.25);
      padding: 28px 0 20px 30px;

      .list_center {
        height: 80px;
        align-items: center;
        justify-content: space-between;
        padding-right: 10px;

        // .yb {
        //   width: 55%;
        // }
        .list_center_top {
          align-items: center;
          position: relative;
        }

        .list_center_img {
          position: absolute;
          top: 7px;

          img {
            height: 20px;
          }
        }

        .list_center_text {
          margin-left: 52px;
        }

        .p1 {
          font-size: 35px;
        }
      }

      .list_bott {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .list :hover {
    transform: scale(1.1);
  }

  .list_li :hover {
    transform: scale(1);
  }

  .zwf {
    width: 100%;
    height: 2px;
    background: rgba(166, 168, 191, 0.25);
    // opacity: 0.25;
  }

  .echart {
    width: 100%;
    height: 650px;
    border: 1px solid rgba(166, 168, 191, 0.25);
    margin-bottom: 34px;
    position: relative;

    .charts {
      width: 100%;
      height: 100%;
      pointer-events: auto;
    }

    .broken {
      position: absolute;
      align-items: center;
      top: 20px;
      left: 70px;

      .broken_input {
        width: 20px;
        height: 20px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .broken_inputtwo {
        width: 20px;
        height: 20px;
        border: 2px solid #be3c6e;
        margin-right: 10px;
      }

      .broken_inputsher {
        width: 30px;
        height: 30px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .broken2 {
      position: absolute;
      align-items: center;
      top: 20px;
      left: 270px;

      .broken_input {
        width: 20px;
        height: 20px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .broken_inputtwo {
        width: 20px;
        height: 20px;
        border: 2px solid #be3c6e;
        margin-right: 10px;
      }

      .broken_inputsher {
        width: 30px;
        height: 30px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .broken4 {
      position: absolute;
      align-items: center;
      top: 20px;
      right: 20px;

      .p1 {
        padding: 9px;
      }

      .p2 {
        width: 2px;
        height: 24px;
        background: rgba(166, 168, 191, 0.25);
        margin: 0 10px;
      }

      .p3 {
        padding: 9px;
      }
    }
  }

  .broken3 {
    position: absolute;
    align-items: center;
    width: 300px;
    bottom: 10px;
    left: 50%;
    margin-left: -150px;

    .broken3_one {
      margin-right: 50px;
    }

    .broken_input {
      margin-right: 10px;
    }
  }

  label {
    display: block;
    height: 20px;
    width: 60px;
    border-radius: 1em;
    border: 0.1px solid gainsboro;
    transition: background-color 1s;
  }

  #turn {
    display: none;
  }

  label::before {
    content: "";
    display: block;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    background-color: #b4b0b0;
    transition: margin 0.5s;
  }

  #turn:checked+label::before {
    margin-left: 38px;
    margin-top: -2px;
    background-color: rgba(252, 103, 128, 1);
    border: 2px solid #fc6780;
    // box-shadow: 1px 1px 10px #888888;
  }

  #turn:checked+label {
    background-color: rgba(252, 103, 128, 0.5);
    // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
  }

  #turn2 {
    display: none;
  }

  label::before {
    content: "";
    display: block;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    background-color: #b4b0b0;
    transition: margin 0.5s;
  }

  #turn2:checked+label::before {
    margin-left: 38px;
    margin-top: -2px;
    background-color: rgba(251, 206, 140, 1);
    border: 2px solid #fbce8c;
    // box-shadow: 1px 1px 10px #888888;
  }

  #turn2:checked+label {
    background-color: rgba(251, 206, 140, 0.5);
    // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
  }

  .imgs_inpusts {
    #turn3 {
      display: none;
    }

    #turn3:checked+label::before {
      margin-left: 38px;
      margin-top: -2px;
      background-color: rgba(120, 146, 236, 1);
      border: 2px solid #7892EC;
      // box-shadow: 1px 1px 10px #888888;
    }

    #turn3:checked+label {
      background-color: rgba(120, 146, 236, 0.5);
      // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
    }
  }

  #turn4 {
    display: none;
  }

  #turn4:checked+label::before {
    margin-left: 38px;
    margin-top: -2px;
    background-color: rgba(120, 146, 236, 1);
    border: 2px solid #7892EC;
    // box-shadow: 1px 1px 10px #888888;
  }

  #turn4:checked+label {
    background-color: rgba(120, 146, 236, 0.5) // background-image: linear-gradient(to right,#9B63FF,#462188); 背景渐变
  }

  .proportion {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 34px;

    .proportion_left {
      width: 55%;
      // border: 1px solid rgba(166,168,191,0.25);
    }

    .proportion_righ {
      width: 35%;

      .top_center {
        width: 120px;

        .top_center_two {
          width: 100% !important;
        }
      }

      // border: 1px solid rgba(166,168,191,0.25);
    }

    .proportion_left_c {
      width: 100%;
      height: 74px;
      border-top: 2px solid rgba(166, 168, 191, 0.25);

      .top {
        border: none;
      }
    }

    .imgs {
      width: 100%;
      height: 260px;
      border: 1px solid rgba(166, 168, 191, 0.25);
      padding-top: 10px;
      margin-top: 20px;

      // position: relative;
      .title_text {
        margin-top: 16px;
      }

      .echatr {
        width: 100%;
        height: 282px;
      }

      .bott_list_top {
        height: 30px;
        padding: 15px 21px 0 30px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 13px;

        .botts {
          align-items: center;

          p {
            height: 100%;
            line-height: 30px;
          }

          .p1 {
            padding: 0 9px;
          }

          .p2 {
            width: 2px;
            height: 24px;
            background: rgba(166, 168, 191, 0.25);
            margin: 0 10px;
          }

          .p3 {
            padding: 0 9px;
          }
        }
      }

      .bott_list3 {
        width: 100%;
        height: 200px;
      }

      .imgs_inpusts {
        width: 50%;
        height: 1005;
        align-items: center;
        justify-content: center;

        .broken3_one {
          margin-bottom: 23px;
        }

        .broken3_two {
          margin-top: 23px;
        }

        .broken_input {
          margin-right: 25px;
        }
      }
    }
  }

  .bott {
    width: 100%;
    padding-bottom: 34px;
    border-top: 2px solid rgba(166, 168, 191, 0.25);

    .bott_list {
      width: 100%;
      border: 1px solid rgba(166, 168, 191, 0.25);
      padding: 23px 23px 39px 29px;

      .bott_list_top {
        height: 30px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 13px;

        .botts {
          align-items: center;

          p {
            height: 100%;
            line-height: 30px;
          }

          .p1 {
            padding: 0 9px;
          }

          .p2 {
            width: 2px;
            height: 24px;
            background: rgba(166, 168, 191, 0.25);
            margin: 0 10px;
          }

          .p3 {
            padding: 0 9px;
          }
        }
      }

      .bott_list_center {
        .toop_title {
          // width: 100%;
          height: 37px;
          background: rgba(167, 169, 192, 0.25);
          align-items: center;
          padding-left: 19px;

          .one1 {
            width: 4%;
          }

          .one {
            width: 11%;
          }

          .fooer {
            width: 30%;
          }

          .fooer2 {
            width: 20%;
          }
        }

        .toop_center {
          height: 47px;
          border-bottom: 1px solid #d8dee8;
          align-items: center;
          padding-left: 19px;

          .one1 {
            width: 4%;
          }

          .one {
            width: 11%;
          }

          .fooer {
            width: 30%;
            padding-right: 10px;
            box-sizing: border-box;
            overflow: hidden;
            /*超出的部分隐藏起来。*/
            white-space: nowrap;
            /*不让文本换行,在一行显示*/
            text-overflow: ellipsis;
            /*超出显示...*/
          }

          .fooer2 {
            width: 20%;
          }
        }
      }
    }

    .top_center {
      width: 120px;

      .top_center_two {
        width: 100%;
      }
    }

    .tops {
      width: 100%;
      height: 84px;
      // border-bottom: 2px solid rgba(166, 168, 191, 0.25);
      align-items: center;
      position: relative;
      margin-bottom: 24px;

      .top_center {
        width: 120px;
        position: absolute;
        right: 0;

        .top_center_two {
          width: 100%;

          .scect {
            border-bottom: 1px solid;
            position: relative;
            align-items: center;
            padding-bottom: 3px;
            margin-top: 5px;

            i {
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_centers {
    width: 1600px;
    margin: 0 auto;
  }

  .titles {
    padding-left: 6px;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_centers {
    width: 1920px;
    margin: 0 auto;
  }

  .titles {
    padding-left: 35px;
  }
}


/deep/ textarea {
  padding-right: 45Px;
  height: 100% !important;
  border-radius: 10px !important;
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  background-color: #fff;
}

.aibox {
  position: fixed;
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 500px;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 0 2px 2px #ecf5ff;
  top: 0;
  right: 0;
  z-index: 999 !important;
  background-color: #f8e4eb;
  box-sizing: border-box;

  #aibtn {
    position: absolute;
    width: 75Px;
    height: 75Px;
    top: 10%;
    left: -75Px;
    text-align: center;
    cursor: pointer;
    border-radius: 50% 0% 0% 50%;
    background-color: #f8e4eb;
    z-index: 9999 !important;

    .block1 {
      width: 16Px;
      height: 16Px;
      z-index: 9998 !important;
      position: absolute;
      right: 0;
      top: -16Px;

      #aiblock1 {
        width: 100%;
      }
    }


    .block2 {
      width: 16Px;
      height: 16Px;
      z-index: 9998 !important;
      position: absolute;
      right: 0px;
      bottom: -15Px;

      #aiblock2 {
        width: 100%;
      }
    }


    #bot {
      width: 50Px;
      margin-top: 22Px;
    }
  }
}

#aibtn3 {
  position: fixed;
  width: 60Px;
  height: 60Px;
  border-radius: 50%;
  background-color: #34e7e7;
  right: 20Px;
  bottom: 150Px;
  z-index: 9999 !important;
  cursor: pointer;

  img {
    margin-top: 8px;
    width: 100%;
  }

  &:hover {
    transform: scale(1.3);
    transition: all .4s;
  }

  @keyframes aiaction2 {

    100% {
      scale: (1.3);
    }
  }

  @keyframes aiaction {

    0%,
    50% {
      transform: translateY(-20px);
    }

    25%,
    75% {
      transform: translateY(0);
    }
  }
}

.left {
  width: 200Px;
  border-right: 2px solid #fff
}

.addchat {
  height: 80PX;
  width: 250Px;
  position: absolute;
  bottom: 0;
  padding: 20Px 20Px 20Px 25Px;

  .addbtn {
    width: 150Px;
    height: 40Px;
    border: 5px solid transparent;
    border-radius: 10px;
    background-image: linear-gradient(to right, #fff, #fff), linear-gradient(to right, red, #578aef);
    background-color: #d4f1ff;
  }
}

.right {
  width: 375Px;
  height: 100%;

  .messageTip {
    // width: 150Px;
    padding: 0 15Px;
    height: 60Px;
    line-height: 60Px;
    position: absolute;
    text-align: center;
    z-index: 999;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8Px;
    background-color: #be3c6e;
    color: #fff;
    font-weight: bold;

  }
}

.title {
  position: relative;
  // top: 0;
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(to right, #a9b7c5 50%, rgba(190, 60, 110, 1));

  .top-minus {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 40px;
    top: 0;
    cursor: pointer;
    color: #fff
  }

  .top-close {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
    color: #fff
  }
}

.contentbox {
  box-sizing: border-box;
  // position: absolute;
  width: 100%;
  height: calc(100% - 170px);
  flex-grow: 2;
  // height: 100%;
  // top: 0;
  // padding-bottom: 130Px;
  overflow: hidden;
  overflow-y: scroll;


  .loadingbox {
    width: 50px;
  }

  .loadingbox>div {
    width: 10px;
    height: 10px;
    background-color: #33e5e5;
    border-radius: 50%;
    display: inline-block;
    animation: action 1.5s infinite ease-in-out;
    animation-fill-mode: both;
  }

  .loadingbox .point1 {
    animation-delay: -0.3s;
  }

  .loadingbox .point2 {
    animation-delay: -0.1s;
  }

  @keyframes action {

    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1.0);
    }
  }

}


.chat-list {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow: auto;

  .tastrule_center {
    white-space: pre-wrap;
  }

  >div {
    display: flex;
    margin-top: 1rem;

    >div {
      max-width: 250Px;
      padding: 0.6rem;
      opacity: 0.8;

      font-size: 0.9rem;
      font-family: FZLanTingHei-L-GBK;
      font-weight: 400;
      color: #c5e7ff;
      text-align: start;
    }

    .bot {
      padding: 10Px 9Px;
      letter-spacing: .5px;
      font-weight: 500;
      font-size: 14px;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      align-self: flex-end;
      background: #fff;
      color: #000;
      border-radius: 16px 16px 16px 16px;
      text-transform: uppercase;
    }

    .user {
      color: #fff;
      background-color: #be3c6e;
      padding: 10Px 9Px;
      letter-spacing: .5px;
      font-weight: 500;
      font-size: 14px;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      align-self: flex-start;
      border-radius: 16px 16px 16px 16px;
    }

    .img1 {
      width: 50Px;
    }

    .img2 {
      width: 2rem;
      height: 2rem;
      margin-left: 1rem;
    }
  }

  >.botbox {
    align-self: flex-start;
  }

  >.userbox {
    align-self: flex-end;
  }

  // >div:nth-of-type(odd) {
  //   align-self: flex-end;
  // }

  // >div:nth-of-type(even) {
  //   align-self: flex-start;
  // }
}

.el-textarea {
  position: absolute;
  height: 100px;
  width: 94%;
  bottom: 8px;
  right: 3%;
}


/* 1.过渡动画 */
@keyframes axisX {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0px);
  }
}

@keyframes axisX2 {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes axisX3 {
  0% {
    opacity: 0;
  }

  70% {
    opacity: 0;
  }

  80% {
    opacity: 0.7;
  }

  90% {
    opacity: 0.9;
  }

  100% {
    opacity: 1;
  }
}

@keyframes widthX {
  from {
    width: 0px;
  }

  to {
    width: 200Px;
  }
}

@keyframes opacityLing {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

/* 2. 过渡类名 */
/* 开始 */
.ai1-enter-active {
  animation: axisX 1s;
}

/* 结束 */
.ai1-leave-active {
  animation: axisX .5s reverse;
}

/* 开始 */
.ai2-enter-active {
  animation: axisX 1s;
}

/* 结束 */
.ai2-leave-active {
  animation: axisX .5s reverse;
}


.ai3-enter-active {
  animation: axisX3 1s;
}

/* 结束 */
.ai3-leave-active {
  animation: axisX2 0s reverse;
}

.left-enter-active {
  animation: widthX .7s;
}

.left-leave-active {
  animation: widthX .7s reverse;
}

.close-enter-active {}

.close-leave-active {
  animation: opacityLing 1s;
}

</style>
<style lang="less">
.bulletinBoard {
  .el-dropdown {
    width: 100%;
  }
}

.el-dropdown-menu__item {
  padding: 0 !important;
  color: #000;
}

.bulletinBoard.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #000;
  background: none;
}
</style>